import _ from 'underscore';

const Permission = APP_CONSTANTS.PERMISSIONS;

class AppNavigationOption {
  constructor(key, data, currentUser) {
    this.key = key;
    this.data = data;
    this.currentUser = currentUser;

    const userPermissions = currentUser.rolePermissionNames;
    if (this.currentUser.admin) userPermissions.push(Permission.ADMIN);
    if (this.currentUser.is_mentor) userPermissions.push(Permission.MANAGER);
    if (this.currentUser.is_editor) userPermissions.push(Permission.EDITOR);
    if (this.currentUser.isAcademyAdmin) userPermissions.push(Permission.ACADEMY_ADMIN);
    this.userPermissions = userPermissions;
  }

  values() {
    const newData = { ...this.data };
    if (newData.options) {
      const processedOptions = this._processedOptions();
      if (processedOptions != null && processedOptions.length > 0) {
        newData.options = processedOptions;
      } else {
        delete newData.options;
      }
    }
    if (newData.submenus) {
      const processedSubmenus = this._processedSubmenus();
      if (processedSubmenus != null && Object.keys(processedSubmenus).length > 0) {
        newData.submenus = processedSubmenus;
      } else {
        delete newData.submenus;
      }
    }
    if (newData.href) {
      const processedHref = this._processedHref();
      if (processedHref != null) {
        newData.href = processedHref;
      } else {
        delete newData.href;
      }
    }
    if (newData.hrefFnc == null) {
      delete newData.hrefFnc;
    }
    return newData;
  }

  shouldShow() {
    return this._shouldShowHelper(this.data);
  }

  sortOrder() {
    const { sortOrder } = this.data;
    return sortOrder || 0;
  }

  _processedOptions() {
    const { options } = this.data;
    if (!options) return null;

    return options.filter((option) => this._shouldShowHelper(option));
  }

  _processedSubmenus() {
    const { submenus } = this.data;
    if (!submenus) return null;

    const subNavOptions = {};
    Object.entries(submenus).forEach(([key, value]) => {
      const subNavOption = new AppNavigationOption(key, value, this.currentUser);
      if (subNavOption.shouldShow()) {
        subNavOptions[key] = subNavOption.values();
      }
    });
    return subNavOptions;
  }

  // Very hacky... TODO: make less hacky ;)
  _processedHref() {
    const { href } = this.data;
    if (!href) return null;
    let newHref = href;

    if (!this.userPermissions.includes(Permission.ADMIN) && this.key === 'SETUP') {
      if (
        this.userPermissions.includes(Permission.GROUPS_MANAGEMENT) &&
        !this.userPermissions.includes(Permission.USERS_MANAGEMENT)
      ) {
        newHref = '/admin/groups';
      } else if (this.userPermissions.includes(Permission.WORKFLOWS_MANAGEMENT)) {
        newHref = '/admin/workflows';
      } else if (this.userPermissions.includes(Permission.BADGES_MANAGEMENT)) {
        newHref = '/admin/badges';
      } else if (this.userPermissions.includes(Permission.CMS_MANAGEMENT)) {
        newHref = '/admin/cms';
      } else {
        newHref = '/admin/users';
      }
    }
    return newHref;
  }

  _shouldShowHelper(option) {
    const hasPermissions = this._userHasPermissionForOption(option?.allowedPermissions);
    if (!hasPermissions) return false;

    return typeof option.shouldShow === 'function' ? option.shouldShow(this.currentUser, this.userPermissions) : true;
  }

  _userHasPermissionForOption(allowedPermissions) {
    if (!allowedPermissions) return true;

    return _.some(this.userPermissions, (userPermission) => allowedPermissions.includes(userPermission));
  }
}

export default AppNavigationOption;
